import { Typography } from 'ui/typography';

interface ProductDetailsProps {
  description?: string;
  customClass?: string;
}

const ProductDetails = ({
  description,
  customClass,
}: ProductDetailsProps): React.JSX.Element => (
  <div className={customClass}>
    <Typography
      data-testid="client-product-details-heading"
      variant="h3"
      sx={{ mb: 2 }}
    >
      Product Details
    </Typography>
    <p className="text-gray-700 break-words">{description}</p>
  </div>
);

export default ProductDetails;
